"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSentryReporter = void 0;
var tslib_1 = require("tslib");
var data_extractors_1 = require("./data-extractors");
var IGNORE_LIST = [
    // Wix
    /wix-style-react/,
    /cdn-wix.sessionstack.com/,
    // 3rd party
    /react-dom/,
    /googleapis.com/,
    // General
    /extensions\//i,
    /^chrome:\/\//i,
    // Answers
    /https:\/\/d2x3xhvgiqkx42\.cloudfront\.net/,
    /https:\/\/anstest-(.)+[.]wixanswers\.com/,
    /https:\/\/(.)+[.]devwixanswers\.com/,
    /https:\/\/answers-callcenter-testing(-.+)*.wixanswers\.com/ // ignore cc testing tenant
];
var IGNORE_ERRORS = [
    'ResizeObserver loop limit exceeded',
];
var createSentryReporter = function (sentry, dsn, integrations) {
    var captureException = function (e, additionalData) {
        var scope = new sentry.Scope();
        if (additionalData) {
            Object.entries(additionalData).forEach(function (key, value) {
                scope.setExtra(key, value);
            });
        }
        sentry.captureException(e, scope);
    };
    var beforeSend = function (event, hint) {
        var _a;
        // handle http error exceptions
        var _b = ((_a = hint.originalException) === null || _a === void 0 ? void 0 : _a.response) || {}, status = _b.status, statusText = _b.statusText, data = _b.data, headers = _b.headers, requestId = _b.requestId;
        if (!!requestId || !!headers) {
            var resolvedRequestId = requestId || headers && headers['x-wix-request-id'] || '';
            var resolvedXSeenBy = headers && headers['x-seen-by'] || '';
            var additionalData = {
                'httpErrorStatus': status,
                'httpErrorStatusText': statusText,
                'httpErrorData': data,
                'X-Wix-Request-Id': resolvedRequestId,
                'X-Seen-By': resolvedXSeenBy
            };
            event.extra = tslib_1.__assign(tslib_1.__assign({}, event.extra), additionalData);
        }
        var ticketId = (0, data_extractors_1.extractTicketId)(location.href);
        if (ticketId) {
            event.tags = tslib_1.__assign(tslib_1.__assign({}, event.tags), { ticket_id: ticketId });
        }
        return event;
    };
    return {
        setup: function (release, optionalSettings) {
            var initIgnoreErrors = (optionalSettings === null || optionalSettings === void 0 ? void 0 : optionalSettings.ignoreErrors) || [];
            var ignoreErrorsModified = initIgnoreErrors.concat(IGNORE_ERRORS);
            var options = tslib_1.__assign({ denyUrls: IGNORE_LIST, ignoreErrors: ignoreErrorsModified }, optionalSettings);
            sentry.init(tslib_1.__assign({ dsn: dsn, release: release, integrations: integrations, tracesSampleRate: 1.0, debug: process.env.NODE_ENV === 'development', environment: process.env.NODE_ENV, beforeSend: beforeSend }, options));
        },
        reportError: function (e, additonalData) { return captureException(e, additonalData); },
        indentify: function (user) { return sentry.setUser({ id: user.id }); },
        logMessage: function (msg) { return sentry.addBreadcrumb(msg); },
        trackEvent: function (ev) { return sentry.captureMessage(ev); },
        setTag: function (key, value) { return sentry.configureScope(function (scope) { return scope.setTag(key, value); }); }
    };
};
exports.createSentryReporter = createSentryReporter;
//# sourceMappingURL=index.js.map